import axios from 'axios';
import Swal from 'sweetalert2';

export const dashboardMethodBooks = {
    fetchFrequentlyUsedTiles(book) {
        const requestId = (this.frequentTilesRequestId || 0) + 1;
        this.frequentTilesRequestId = requestId;
        this.frequentTilesLoading = true;
        this.frequentTilesError = null;

        const apiClient = this.httpClient || axios;

        return apiClient({
            method: 'get',
            url: this.baseAPIURL + '/apiv3/listfrequentlyusedtiles.json',
            params: {
                book_code: book,
            },
            headers: {
                auth: this.$store.getters.auth_token,
            },
        })
            .then((response) => {
                if (this.frequentTilesRequestId !== requestId) {
                    return null;
                }

                const items = Array.isArray(response?.data?.data) ? response.data.data : [];
                this.frequentTilesCurrentBook = items;

                return items;
            })
            .catch(() => {
                if (this.frequentTilesRequestId !== requestId) {
                    return null;
                }

                this.frequentTilesCurrentBook = [];
                this.frequentTilesError = 'Failed to load frequently used tiles.';

                return [];
            })
            .finally(() => {
                if (this.frequentTilesRequestId === requestId) {
                    this.frequentTilesLoading = false;
                }
            });
    },

    loadBooks(){
        for ( var i=0; i < this.$store.getters.books.length; i++) {
            var bodyFormData = new FormData();
            bodyFormData.append("code", this.$store.getters.books[i]);
                axios({
                    method: "post",
                    url: this.baseAPIURL+"/apiv3/getbook.json",
                    data: bodyFormData,
                    headers: {
                        "auth": this.$store.getters.auth_token,
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(response => {
                    //handle success
                    this.$store.dispatch('setBookAndDesc', {"title":response.data.books[0].code, "desc":response.data.books[0].description});
                });
        }
    },

    book_sync() {

                for (var i=0; i<this.checkedBooks.length; i++) {
                    if (this.$store.getters.books.includes(this.checkedBooks[i].toUpperCase())) {
                        if (!this.$store.getters.active_books.includes(this.checkedBooks[i].toUpperCase())) {
                            var message = this.checkedBooks[i].toUpperCase()+" is already added but disabled on settings page.";
                        } else {
                            message = this.checkedBooks[i].toUpperCase()+" is already added.";
                        }
                        this.$moshaToast(message, { type: "warning" });
                    } else {
                        var bodyFormData = new FormData();
                        bodyFormData.append("code", this.checkedBooks[i]);
                        axios({
                            method: "post",
                            url: this.baseAPIURL+"/apiv3/getbook.json",
                            data: bodyFormData,
                            headers: {
                                "auth": this.$store.getters.auth_token,
                                "Content-Type": "multipart/form-data",
                            },
                        })
                        .then(response => {
                            //handle succes
                                var responseData = JSON.parse(JSON.stringify(response.data.books));
                                this.$store.dispatch('setActiveBooks', responseData[0].code);
                                this.$store.dispatch('addBook', responseData[0].code);
                                this.$store.dispatch('setBookAndDesc', {"title":response.data.books[0].code, "desc":response.data.books[0].description});



                        }).catch(error => {
                            console.log("Error: "+ error);
                            this.$moshaToast("No access to book!", { type: "danger" });
                        });
                    }             
                }

                this.syncButton = "Syncing...";

                setTimeout(() => {
                    this.$moshaToast("Books synced successfully!", { type: "success" });
                    this.$store.dispatch("updateNewLoad", false);
                    this.newloaded = false;
                    this.syncButton = "Continue";
                }, 1000);
    },

    select_books() {

                if (this.checkedBooks.length == this.newload_data.length) {
                    this.selectAllBooks = 0;
                } else {
                    this.selectAllBooks = 1;
                }
                
    },

    select_all_books() {
                this.checkedBooks = [];

                if (this.selectAllBooks == 1) {
                    this.checkedBooks.push(...this.newload_data);
                } else {
                    this.checkedBooks = [];
                }
    },

    skipBookSync() {
                this.$moshaToast("Continuing without syncing books", { type: "info" });
                this.$store.dispatch("updateNewLoad", false);
                this.newloaded = false;
                this.syncButton = "Continue";
    },

    
    selectBook (book) {
        this.isThereTile = true;
        this.tile_loaded = false;
        this.load_current_icon = false;

        this.$gtag.event('selectBook', {
            'book_visited': book
        });

            this.openSections = "";
            this.$store.dispatch('setLoading', true);

            this.$store.dispatch('activeBook', book);
            this.fetchFrequentlyUsedTiles(book);

            Object.keys(this.dynamic_mergecodes).map((mergecodes) => {
                delete this.dynamic_mergecodes[mergecodes];
            });

                    this.search_tile = '';
                    this.$store.dispatch('unsetActiveTile');

                    var bodyFormData = new FormData();
                    bodyFormData.append("code", book);

                    var tile_content_obj = [];

                    this.$store.getters.active_pages.map( (page_item) => {
                        page_item.tiles.map( (tile) => {
                                tile_content_obj.push({"book_code": tile.book_code,
                                            "id": tile.id,
                                            "title": tile.title,
                                            "modified": tile.modified
                                })
                        });
                    });

                    axios({
                        method: "post",
                        url: this.baseAPIURL+"/apiv3/getbook.json",
                        data: bodyFormData,
                        headers: {
                            "auth": this.$store.getters.auth_token,
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then(response => {
                          //handle success

                    if (response.data.books.length == 0) {

                        Swal.fire({
                            title: 'Oops!',
                            icon: 'warning',
                            html: '<p style="text-align: center;">Unfortunately, this book has been removed</p>',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: 'Okay',
                            confirmButtonColor: "#145DA0"
                        }).then((result) => {
                            /* isConfirmed, isDenied  */
                            if (result.isConfirmed) {
                                this.$store.dispatch('removeBook', book);
                                this.$store.dispatch('unsetActiveBooks', book);

                                var index = this.books.indexOf(book);
                                if (index > -1) { // only splice array when item is found
                                    this.books.splice(index, 1); // 2nd parameter means remove one item only
                                }

                                if (this.$store.getters.active_books.length == 0) {
                                    this.$store.getters.books.map((item, index) => {
                                        if (index === 0) {
                                            if (this.$store.getters.selected_book == "") {    
                                                this.$store.dispatch('activeBook', item);
                                            }
                                        }
                                        this.$store.dispatch("setActiveBooks", item);
                                    });
                                }
                                

                                this.selectBook(this.books[0]);

                                }
                        });
                    } else {
                        this.$store.dispatch('activeBookDesc', response.data.books[0].description);
                        this.$store.dispatch("setSelectedBookModDate", response.data.books[0].modified);
                        this.$store.dispatch('setPages', response.data.books[0].pages);

                        this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { default_email: response.data.books[0].default_email,
                                                                                        default_number: response.data.books[0].default_number,
                                                                                        sender: response.data.books[0].sender,
                                                                                        user_email: this.$store.getters.auth_user,
                                                                                        user_username: this.$store.getters.auth_username,
                                                                                        });

                        this.book_mergecodes_length =  response.data.books[0].mergecodes.length;
                    

                        response.data.books[0].mergecodes.map((value) => {
                            this.dynamic_mergecodes = Object.assign(this.dynamic_mergecodes, { [Object.keys(value).toString().replace('{{', '').replace('}}','')]: Object.values(value).toString()});
                        });

                        this.$store.dispatch('unsetTiles');
                        response.data.books[0].pages.map( (page_item, index) => {
                            if (index === 0) {   
                                        this.$store.dispatch('activePage', page_item.title);
                            }
                        });

                                  var result_tiles_compare = []; // for comparison
                                  var local_tiles_compare = []; // for comparison

                        response.data.books[0].pages.map((tile) => {
                            tile.tiles.map((items) => {
                                result_tiles_compare.push(items.id); // for comparison
                                Object.keys(tile_content_obj).filter((key) => {


                                    if (tile_content_obj[key].id == items.id) {
                                        
                                        local_tiles_compare.push(tile_content_obj[key].id); // for comparison
                                        
                                        if (tile_content_obj[key].modified != items.modified) {
                                            if (!this.$store.getters.tiles_update.includes(items.id)) {
                                                if (items.flag_icon === 'open_to_clear') {
                                                    this.$store.dispatch('setOpenClear', {"tile_id":items.id, "flag_icon_color": items.flag_icon_color});
                                                } else if (items.flag_icon === 'complete_to_clear') {
                                                    this.$store.dispatch('setCompleteClear', {"tile_id":items.id, "flag_icon_color": items.flag_icon_color});
                                                } else {
                                                    this.$store.dispatch('setTilesUpdated', items.id);
                                                }
                                            }
                                        }
                                    } 
                                });
                            });
                        });    
                        var bookindexToRemove = this.withUpdates.indexOf(book);
                        this.withUpdates.splice(bookindexToRemove, 1);
                        this.$store.dispatch('setLoading', false);
                        
                        this.checkCountTile();
                        }
                    }).catch(error => {
                        if (error.response) {
                            if (error.response.data.code === 401) {
                                Swal.fire({
                                    title: 'Oops!',
                                    icon: 'warning',
                                    html: '<p style="text-align: center;">This session has expired. Please try to login again.</p>',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    confirmButtonText: 'Go to login page',
                                    confirmButtonColor: "#145DA0"
                                }).then((result) => {
                                      /* Read more about isConfirmed, isDenied below */
                                    if (result.isConfirmed) {
                                        this.$store.dispatch('logoutUser');
                                        this.$router.push('/');
                                        this.$moshaToast("You have logged-out!", { type: "success" });
                                    }
                                });
                            } else {
                                this.handle_error();  
                            }
                        } else {
                            this.handle_error(); // Call your error handling function for CORS errors
                        }
                    });
    },

    selectPage (page) {
        this.isThereTile = true;
        this.$gtag.event('selectPage', {
            'page_visited': this.$store.getters.selected_book+'/'+page
        });
        this.search_tile = '';
        this.$store.dispatch('unsetActivePage');
        this.$store.dispatch('activePage', page);

        this.checkCountTile();        
    },

    getActiveBookContent(book_code) {
        return this.$store.getters.books.filter(item => {
            return item.code == book_code;
        });
    },

    handledomainbooksort(){
        axios({
            method: "get",
            url: this.baseAPIURL + "/apiv3/getDomainSort.json",
            headers: {
                "auth": this.$store.getters.auth_token,
                "Content-Type": "multipart/form-data",
            },
        }).then(response => {
            let responseData = response.data;

            try {
                var preload_books_sorted = [];

                // Extract mappings
                var domain_auto = responseData.data.domain_auto || {};
                var default_books_map = responseData.data.default || {};
                var books = this.$store.getters.books; // plain array: ["CSROCKS", "TAP3BOOK", ...]

                // Sort orders (IDs)
                var domain_book_sorts = Object.values(responseData.data.domain_book_sorts || {});
                var default_book_sorts = Object.values(responseData.data.default_book_sorts || {});

                // Map domain IDs → codes/titles
                domain_book_sorts.forEach(id => {
                    let code = domain_auto[id];
                    if (code && !preload_books_sorted.includes(code)) {
                        preload_books_sorted.push(code);
                    }
                });

                // Map default IDs → codes/titles
                default_book_sorts.forEach(id => {
                    let code = default_books_map[id];
                    if (code && !preload_books_sorted.includes(code)) {
                        preload_books_sorted.push(code);
                    }
                });

                // Reorder actual book list
                const reorderedBooks = [
                    // Items from preload_books_sorted in order
                    ...preload_books_sorted.filter(code => books.includes(code)),
                    // Remaining items not in preload_books_sorted
                    ...books.filter(code => !preload_books_sorted.includes(code))
                ];

                // Reset and replace store books
                this.$store.dispatch('resetBooks');
                reorderedBooks.forEach(code => {
                    this.$store.dispatch('setBooks', code);
                });

            } catch (error) {
                console.error("Error parsing JSON:", error.message);
            }
        });
    },
};